import * as d3 from 'd3'

export default {

  methods: {

    event_Link(selection, data_, col_) {

      if (col_.filter == '' || data_[col_.code] == 0) return

      selection
      .attr('cursor', 'pointer')
      .on('mouseover', function() {
          d3.select(this).transition().duration(50).style('opacity', .4)
        })
        .on('mouseout', function() {
          d3.select(this).transition().duration(50).style('opacity', 1)
        })
        .on('click', () => {
          this.link_Action(data_, col_) 
        })
    },

    link_Action(data_, col_) {
      let dataSource = {}

      if(this.radio.visible == 'Y' && data_[this.radio.refCode] != 'OVERALL'){
        this.keys[`KEY${Object.keys(this.keys).length + 1}`] = this.radio.refCode
        Object.keys(this.keys).forEach(d=>{
          dataSource = {...dataSource, [d]: data_[this.keys[d]]}
        })
        delete this.keys[`KEY${Object.keys(this.keys).length}`]
      }else{
        Object.keys(this.keys).forEach(d=>{
          dataSource = {...dataSource, [d]: data_[this.keys[d]]}
        })
      }

      let filterString_ = this.filters[col_.filter] || ''
      let requestText = (col_.json && col_.json != '') ? col_.json : 'request'
      console.log(requestText, dataSource, filterString_)

      // seting request_ from A/G jsonProps
      let request_ = this.getRequestColumnProps(requestText, dataSource, this.ColumnProps)
      if(!request_) return

      if(request_.iFilters.filterString) {
        request_.iFilters.filterString += filterString_ ? ` AND ${filterString_} ` : ''
      } else {
        request_.iFilters.filterString = filterString_||''
      }

      // Combine filterStrings
      request_ = {...request_,
        filters : {
          ...this.FilterValues,
          ...request_.filters,
        },
        iFilters: { 
          filterString : request_.iFilters.filterString||'',
          inputFilter : request_.iFilters.inputFilter,},
      }
      this.$emit('request-action', request_)
    },

  } 
}